import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import { ToastProvider } from './context/ToastContext';
import { bootstrap, refresh } from 'shared/data/episodeRepository';
import './i18n/config';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const REFRESH_INTERVAL_MS = 2 * 60 * 60 * 1000;

async function start() {
  await bootstrap();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AudioPlayerProvider>
              <App />
            </AudioPlayerProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );

  window.setInterval(() => {
    void refresh();
  }, REFRESH_INTERVAL_MS);
}

start();

reportWebVitals();
